import React, { useMemo, useState } from "react";
import { IconButton, Badge, Menu, MenuItem } from "@mui/material";
import SvgIcon from "../../helpers/SvgIcon";
import { expeditionRoutes } from "../routesConstants";
import { useAppSelector } from "../../redux/hooks";

export default function AlertsBellMenu() {
  const {
    admin: {
      alertsCount: {
        data: { total: totalAlertsCount, data: alertsCountData },
      },
    },
  } = useAppSelector((state) => ({ admin: state.admin }));

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(e.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const alertsCountDropdownValues = useMemo(
    () =>
      (alertsCountData ?? []).map((item) => ({
        id: item.id_client,
        label: item.client,
        count: item.puncte_nevalidate,
      })),
    [alertsCountData],
  );

  return (
    <>
      <IconButton
        size="large"
        aria-label={`show ${totalAlertsCount} new notifications`}
        color="inherit"
        onClick={handleOpen}>
        <Badge badgeContent={totalAlertsCount} color="error">
          <SvgIcon type="NOTIFICATIONS_ICON" />
        </Badge>
      </IconButton>

      <Menu
        title="Client cu puncte nelivrate"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        {alertsCountDropdownValues && alertsCountDropdownValues.length ? (
          alertsCountDropdownValues.map((item, idx) => (
            <MenuItem key={idx} onClick={() => handleClose()}>
              <a
                className="my-auto p-2 text-black"
                href={`/${expeditionRoutes.clients}/${item.id}/${expeditionRoutes.clientsWorkingPoints}?denumireClient=${item.label}`}>
                {item.label} <span className="text-danger">({item.count})</span>
              </a>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>Fara notificari</MenuItem>
        )}
      </Menu>
    </>
  );
}
